import avantisLogo from './assets/logo_avantis.png';
import agencySeal from './assets/logo_avantis.png'; // RePLACING SEAL WITH LOGO
import agencyBuilding from './assets/agency_building.jpg'; 
import agentAnneCatherine from './assets/agent-anne-catherine-plez.jpg'; 

export const COLORS = {
    primary: '#EA723D', // Orange Avantis (ex-SCBI)
    secondary: '#1A2A3A', // Bleu nuit
    text: '#333333',
    lightGray: '#F5F5F5',
    white: '#FFFFFF'
};

export const AGENCY_INFO = {
    name: "Anne-Catherine PLEZ",
    tagline: "L'expertise immobilière au Luxembourg",
    phone: "+352 671 260 273",
    whatsapp: "+33 6 11 40 52 99",
    email: "contact@avantis-immo.lu",
    address: "39 rue Laroche, 1918 Weimerskirch, Luxembourg",
    role: "Agente immobilière co-responsable",
    sector: "Luxembourg",
    photo: agentAnneCatherine,
    facebookPage: "https://www.facebook.com/profile.php?id=100063819152541&locale=fr_FR#",
    instagram: "https://www.instagram.com/"
};

export const AGENT_INFO = AGENCY_INFO;

export const LOGO_URL = avantisLogo;
export const AGENCY_SEAL = agencySeal;

export const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(price);
};
